import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=87025530&scoped=true"
import script from "./Status.vue?vue&type=script&lang=ts"
export * from "./Status.vue?vue&type=script&lang=ts"
import style0 from "./Status.vue?vue&type=style&index=0&id=87025530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87025530",
  null
  
)

export default component.exports